import PropTypes from 'prop-types';
import React from 'react';

import './m-label.scss';

const MLabel = props => {
  const className = `m-label ${props.inline ? ' inline' : ''} ${
    props.onClick ? ' clickable' : ''
  }`;
  return (
    <div className={className} style={props.style} onClick={props.onClick}>
      {props.text}
    </div>
  );
};

MLabel.propTypes = {
  text: PropTypes.string,
  style: PropTypes.object,
  inline: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MLabel;
